import { useContext, useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

import { AuthContext } from "../AuthContext";

export default function SessionManager() {
  const SSO_PORTAL_URL_IFRAME = new URL(
    "/silent.html",
    process.env.REACT_APP_SSO_PORTAL_URL
  ).toString();

  const iframeRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  const [isExtending, setIsExtending] = useState(false);
  const { logout } = useContext(AuthContext);

  function handleEvent(data) {
    switch (data.type) {
      case "TOKEN_EXPIRING":
        console.log("[Client] Token expiring");
        setShowPopup(true);
        break;

      case "TOKEN_REFRESHED":
        console.log("[Client] Token refreshed");
        localStorage.setItem("sso_token", data.idToken);
        setIsExtending(false);
        setShowPopup(false);
        break;

      case "REFRESH_DENIED":
        console.log("[Client] Refresh denied");
        setShowPopup(false);
        break;

      case "LOGOUT":
        console.log("[Client] Logout");
        logout();
        break;
    }
  }

  // Listen to iframe messages
  useEffect(() => {
    const onMessage = (e) => handleEvent(e.data);
    window.addEventListener("message", onMessage);

    return () => window.removeEventListener("message", onMessage);
  }, []);

  // User approves refresh
  const approveRefresh = () => {
    setIsExtending(true);
    iframeRef.current?.contentWindow?.postMessage(
      { type: "REFRESH_APPROVED" },
      "*"
    );
  };

  // User denies
  const denyRefresh = () => {
    setShowPopup(false);
    iframeRef.current?.contentWindow?.postMessage(
      { type: "REFRESH_DENIED" },
      "*"
    );
  };

  return (
    <>
      {/* Invisible iframe */}
      <iframe
        ref={iframeRef}
        src={SSO_PORTAL_URL_IFRAME}
        style={{ display: "none" }}
        title="SSO Portal"
      />

      <Dialog
        header="Session Extension"
        visible={showPopup}
        onHide={denyRefresh}
        style={{ width: "500px" }}
        footer={
          <div>
            <Button
              label="Cancel"
              icon="pi pi-times"
              onClick={denyRefresh}
              className="p-button-text"
            />
            <Button
              label={isExtending ? "Extending..." : "Extend"}
              icon={isExtending ? "pi pi-spin pi-spinner" : "pi pi-check"}
              onClick={approveRefresh}
            />
          </div>
        }
      >
        <p>
          Your session is about to expire. Do you want to extend your session?
        </p>
      </Dialog>
    </>
  );
}
